// @flow

import merge from 'lodash/merge';
import includes from 'lodash/includes';

import type { Campaign } from "../lib/Campaign";
import type { ChallengeStyle } from "../lib/Challenge";


// 'Classic' Kwizzad coloring, also used as fallback if a style parameter is missing
export const defaultStyle = {
    primaryColor: 'rgb(255, 165, 31)',
    secondaryColor: 'rgb(229, 93, 123)',
    textColor: '#111',
    background: {
        portrait: 'url(/backgrounds/portrait.svg)',
        landscape: 'url(/backgrounds/landscape.svg)',
        forTextContent: 'white',
    },
    buttonColors: {
        normal: ['rgb(255, 165, 31)', 'rgb(255, 165, 31)'],
        right: ['#0AA85B', 'rgb(255, 165, 31)'],
        wrong: ['#EB647E', 'rgb(255, 165, 31)'],
    },
    imageGradients: {
        right: ['rgba(10, 168, 91, 0.7)', 'rgba(3, 57, 80, 0.89)'],
        wrong: ['rgba(251, 0, 55, 0.7)', 'rgba(29, 31, 86, 0.89)'],
        neutral: ['rgba(90, 181, 228, 0.7)', 'rgba(29, 31, 86, 0.89)'],
    },
};

// Keys must be lowercase here to work.
const appBasedStyles: {[string]: ChallengeStyle} = {
    kwizzmo: {
        background: {
            portrait: 'url(/backgrounds/kwizzmo.svg)',
            landscape: 'url(/backgrounds/kwizzmo.svg)',
        },
        imageGradients: {
            right: ['rgba(10, 168, 91, 0.5)', 'rgba(10, 168, 91, 0.5)'],
            wrong: ['rgba(235, 100, 126, 0.5)', 'rgba(235, 100, 126, 0.5)'],
        }
    },
    tvsmiles: {
        background: {
            portrait: 'url(/backgrounds/tvsmiles.svg)',
            landscape: 'url(/backgrounds/tvsmiles.svg)',
        },
        imageGradients: {
            right: ['rgba(10, 168, 91, 0.5)', 'rgba(10, 168, 91, 0.5)'],
            wrong: ['rgba(235, 100, 126, 0.5)', 'rgba(235, 100, 126, 0.5)'],
        }
    },
    modealz: {
        background: {
            portrait: '#208d8a',
            landscape: '#208d8a',
        },
    },
    carlos: {
        background: {
            portrait: '#FFFFFF',
            landscape: '#FFFFFF',
        },
        imageGradients: {
            right: ['rgba(10, 168, 91, 0.5)', 'rgba(10, 168, 91, 0.5)'],
            wrong: ['rgba(235, 100, 126, 0.5)', 'rgba(235, 100, 126, 0.5)'],
        },

    }
};

const tagBasedStyles: {[string]: ChallengeStyle} = {
    entertainment: {
        primaryColor: '#FF4C00',
        secondaryColor: '#FF4C00',
        buttonColors: {
            normal: ['#FF4C00', '#FF4C00'],
            right: ['#0AA85B', '#0AA85B'],
            wrong: ['#EB647E', '#EB647E'],
        },
        imageGradients: {
            neutral: ['rgba(247, 183, 5, 0.5)', 'rgba(247, 183, 5, 0.5)'],
        }
    },
    fakten: {
        primaryColor: '#03f0d6',
        secondaryColor: '#059989',
        buttonColors: {
            normal: ['#03E4AE', '#03E4AE'],
            right: ['#03E4AE', '#03E4AE'],
            wrong: ['#EB647E', '#EB647E'],
        },
        imageGradients: {
            neutral: ['rgba(127, 5, 193, 0.5)', 'rgba(127, 5, 193, 0.5)'],
            right: ['rgba(3, 228, 174, 0.5)', 'rgba(3, 228, 174, 0.5)'],
        }
    },
    games: {
        primaryColor: '#c10585',
        secondaryColor: '#fa40bf',
        buttonColors: {
            normal: ['#C10585', '#C10585'],
            right: ['#0AA85B', '#0AA85B'],
            wrong: ['#EB647E', '#EB647E'],
        },
        imageGradients: {
            neutral: ['#00C3E9cc', '#00C3E9cc'],
        }
    },
    marken: {
        primaryColor: '#ff4c00',
        secondaryColor: '#fb7a43',
        background: {
            forTextContent: 'rgb(255, 250, 251)',
        },
        buttonColors: {
            normal: ['#FF004F', '#FF004F'],
            right: ['#0AA85B', '#0AA85B'],
            wrong: ['#EB647E', '#EB647E'],
        },
        imageGradients: {
            neutral: ['rgba(127, 5, 193, 0.5)', 'rgba(127, 5, 193, 0.5)'],
        }
    },
    sport: {
        primaryColor: '#0036c4',
        secondaryColor: '#05b5e7',
        buttonColors: {
            normal: ['#00C3E9', '#00C3E9'],
            right: ['#0AA85B', '#0AA85B'],
            wrong: ['#EB647E', '#EB647E'],
        },
        imageGradients: {
            neutral: ['rgba(193, 5, 133, 0.5)', 'rgba(193, 5, 133, 0.5)'],
        }
    },
};


export function getStyleForCampaign(campaign: Campaign): ChallengeStyle {
    const categoryTags = campaign.categoryTags || [];
    const isSupported = tag => includes(Object.keys(tagBasedStyles), (tag && typeof tag.key === 'string' && tag.key.toLowerCase()));
    const tag = categoryTags.find(isSupported);
    const theme = (tag && typeof tag.key === 'string') ? tag.key.toLowerCase() : 'default';
    // const theme = 'entertainment';
    let projectName;
    if (typeof window.KwizzAdJI !== 'undefined' && typeof window.KwizzAdJI.projectName === 'function') {
        projectName = window.KwizzAdJI.projectName();
    }
    return merge({}, defaultStyle, appBasedStyles[(projectName|| '').toLowerCase()] || {}, tagBasedStyles[theme] || {});
}



// WEBPACK FOOTER //
// ./src/campaign/styles.js